import React, { memo } from 'react';
import AFramePanorama from '../../../AFrame/AFramePanorama';
import AFrameVideo from '../../../AFrame/AFrameVideo';
import MapWrapper from '../../../Map/MapWrapper/MapWrapper';
import Thumbnail from '../../../Media/Thumbnail/Thumbnail';
import Marker from '../../../Map/Marker/Marker';
import RadarMarker from '../../../Map/Marker/RadarMarker';
import * as constants from '../../../../constants';

const MiniMapMainMedia = ({
  miniMapView,
  stops,
  panos,
  activeStop,
  tourPublished,
  tourData,
  checkLogoURL,
  closeShareModal,
  changeStop,
  radarPos,
  getPanoRotation,
  path,
  mapToken,
}) => {
  const renderStopMarkers = () => {
    return stops.map(stop => {
      if (!stop) return null;
      stop.activeStop = activeStop;
      stop.radarPos = radarPos;
      return stop.panoNorthView && activeStop === stop.order ? (
        <RadarMarker key={stop.id} data={stop} highlight />
      ) : (
        <Marker
          key={stop.id}
          className="tour-stop-marker-fixed"
          data={stop}
          highlight={activeStop === stop.order}
          changeStop={changeStop}
          showPopup={miniMapView !== 'map'}
        />
      );
    });
  };

  const currentStop = stops[activeStop] || {};
  const {
    panoInitialView,
    panoNorthView,
    ratio,
    mainMediaType,
    panoId = '',
  } = currentStop;

  let panoUrl;
  if (panos[panoId] && panos[panoId].url !== undefined)
    panoUrl = panos[currentStop.panoId].url;
  else panoUrl = constants.DEFAULTPANO;

  return (
    <React.Fragment>
      {miniMapView === 'map' ? (
        [
          <MapWrapper
            key="map"
            miniMapView={miniMapView}
            path={path}
            mapStyle={tourData.tourMapStyle}
            mapRendering={tourData.mapRenderingUrl}
            tourId={tourData.id}
            mapToken={mapToken}
          />,
          renderStopMarkers(),
        ]
      ) : (
        <React.Fragment>
          {mainMediaType === constants.PANOS ? (
            // stop is a pano
            <AFramePanorama
              cube
              initialView={panoInitialView}
              northView={panoNorthView}
              src={panoUrl}
              ratio={ratio}
              tourPublished={tourPublished}
              tourData={tourData}
              checkLogoURL={checkLogoURL}
              closeShareModal={closeShareModal}
              miniMapView={miniMapView}
              getPanoRotation={getPanoRotation}
              activeStop={activeStop}
            />
          ) : mainMediaType === constants.VIDEOS360 ? (
            // stop is a 360video
            <AFrameVideo
              initialView={panoInitialView}
              northView={panoNorthView}
              id={panoId}
              ratio={ratio}
              tourData={tourData}
              miniMapView={miniMapView}
              checkLogoURL={checkLogoURL}
              getPanoRotation={getPanoRotation}
              activeStop={activeStop}
              viewOnly
            />
          ) : (
            // stop is not a pano/360video
            <Thumbnail
              mediaId={panoId}
              mediaType={mainMediaType}
              thumbClass="main-image"
              height={172}
              alt=""
              view
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default memo(MiniMapMainMedia);
